// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-TableTabs-TableTabs-module__root--1-of8","noRound":"src-components-TableTabs-TableTabs-module__noRound--18rdt"};